<template>
  <div>
    <b-modal
      id="modal_form"
      ref="modal_form"
      size="lg"
      :title="modal_titulo"
      :ok-title="modal_botao"
      close-title="Fechar"
      v-model="showModal"
      no-close-on-esc
      no-close-on-backdrop
      :ok-disabled="form.errors.any()"
      @ok="handleOk"
    >
      <form
        @submit.stop.prevent="handleOk"
        @keydown="form.errors.clear($event.target.name)"
      >
        <b-container fluid class="p-a-0">
          <b-row>
            <h6 class="mt-1" style="">Expedidor</h6>
          </b-row>
          <b-row>
            <b-col class="p-0" md="6">
              <label>Expedidor</label>
              <b-form-input
                type="text"
                placeholder="Expedidor"
                v-model="expedidor"
                name="expedidor"
                :disabled="this.modal_acao == 'u'"
              >
              </b-form-input>
            </b-col>
            <b-col class="p-0" md="2" sm="6">
              <label>Inscrição Estadual </label>
              <b-form-input
                type="text"
                placeholder="Inscrição Estadual"
                v-model="form.exp_ie"
                name="exp_ie"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('exp_ie')"
                v-if="form.errors.has('exp_ie')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Município</label>
              <multiselect
                v-model="expMunicipioSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsMunicipio"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Municipio ( Digite ao menos 3 caracteres )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingMunicipio"
                :id="this.exp_uf"
                :disabled="this.exp_uf == null"
                @search-change="listaMunicipio"
                @click="limpaOptionsMunicipio"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Uf</label>
              <multiselect
                v-model="expUfSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="this.$parent.optionsUf"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Uf"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingUf"
                :id="this.exp_uf"
                :disabled="this.exp_uf == null"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Endereço </label>
              <b-form-input
                type="text"
                placeholder="Endereço"
                v-model="form.exp_endereco"
                name="exp_endereco"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('exp_endereco')"
                v-if="form.errors.has('exp_endereco')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Bairro </label>
              <b-form-input
                type="text"
                placeholder="Bairro"
                v-model="form.exp_bairro"
                name="exp_bairro"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('exp_bairro')"
                v-if="form.errors.has('exp_bairro')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>CEP </label>
              <b-form-input
                type="text"
                placeholder="CEP"
                v-model="form.exp_cep"
                name="exp_bairro"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('exp_bairro')"
                v-if="form.errors.has('exp_bairro')"
              ></b-form-feedback>
            </b-col>
            <!-- <b-col class="p-0" md="2">
              <label>Email</label>
              <b-form-input
                type="text"
                placeholder="Email"
                v-model="form.exp_email"
                name="exp_email"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('exp_email')"
                v-if="form.errors.has('exp_email')"
              ></b-form-feedback>
            </b-col> -->
            <b-col class="p-0" md="2">
              <label>Telefone </label>
              <b-form-input
                type="text"
                placeholder="Telefone"
                v-model="form.exp_telefone"
                name="exp_telefone"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('exp_telefone')"
                v-if="form.errors.has('exp_telefone')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row>
            <h6 class="mt-1" style="">Emitente</h6>
          </b-row>
          <b-row>
            <b-col class="p-0" md="6">
              <label>Emitente</label>
              <b-form-input
                type="text"
                placeholder="Emitente"
                v-model="emitente"
                name="emitente"
                :disabled="this.modal_acao == 'u'"
              >
              </b-form-input>
            </b-col>
            <b-col class="p-0" md="2" sm="6">
              <label>Inscrição Estadual </label>
              <b-form-input
                type="text"
                placeholder="Inscrição Estadual"
                v-model="form.emi_ie"
                name="emi_ie"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('emi_ie')"
                v-if="form.errors.has('emi_ie')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Município</label>
              <multiselect
                v-model="emiMunicipioSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsMunicipio"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Municipio ( Digite ao menos 3 caracteres )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingMunicipio"
                :id="this.emi_uf"
                :disabled="this.emi_uf == null"
                @search-change="listaMunicipio"
                @click="limpaOptionsMunicipio"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Endereço </label>
              <b-form-input
                type="text"
                placeholder="Endereço"
                v-model="form.emi_endereco"
                name="emi_endereco"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('emi_endereco')"
                v-if="form.errors.has('emi_endereco')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Bairro </label>
              <b-form-input
                type="text"
                placeholder="Bairro"
                v-model="form.emi_bairro"
                name="emi_bairro"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('emi_bairro')"
                v-if="form.errors.has('emi_bairro')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>CEP </label>
              <b-form-input
                type="text"
                placeholder="CEP"
                v-model="form.emi_cep"
                name="emi_cep"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('emi_cep')"
                v-if="form.errors.has('emi_cep')"
              ></b-form-feedback>
            </b-col>
            <!-- <b-col class="p-0" md="2">
              <label>Email</label>
              <b-form-input
                type="text"
                placeholder="Email"
                v-model="form.emi_email"
                name="emi_email"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('emi_email')"
                v-if="form.errors.has('emi_email')"
              ></b-form-feedback>
            </b-col> -->
            <b-col class="p-0" md="2">
              <label>Telefone </label>
              <b-form-input
                type="text"
                placeholder="Telefone"
                v-model="form.emi_telefone"
                name="emi_telefone"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('emi_telefone')"
                v-if="form.errors.has('emi_telefone')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row>
            <h6 class="mt-1" style="">Remetente</h6>
          </b-row>
          <b-row>
            <b-col class="p-0" md="6">
              <label>Remetente</label>
              <b-form-input
                type="text"
                placeholder="Remetente"
                v-model="remetente"
                name="remetente"
                :disabled="this.modal_acao == 'u'"
              >
              </b-form-input>
            </b-col>
            <b-col class="p-0" md="2" sm="6">
              <label>Inscrição Estadual </label>
              <b-form-input
                type="text"
                placeholder="Inscrição Estadual"
                v-model="form.rem_ie"
                name="rem_ie"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rem_ie')"
                v-if="form.errors.has('rem_ie')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Município</label>
              <multiselect
                v-model="remMunicipioSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsMunicipio"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Municipio ( Digite ao menos 3 caracteres )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingMunicipio"
                :id="this.rem_uf"
                :disabled="this.rem_uf == null"
                @search-change="listaMunicipio"
                @click="limpaOptionsMunicipio"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Uf</label>
              <multiselect
                v-model="remUfSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="this.$parent.optionsUf"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Uf"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingUf"
                :id="this.rem_uf"
                :disabled="this.rem_uf == null"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Endereço </label>
              <b-form-input
                type="text"
                placeholder="Endereço"
                v-model="form.rem_endereco"
                name="rem_endereco"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rem_endereco')"
                v-if="form.errors.has('rem_endereco')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Bairro </label>
              <b-form-input
                type="text"
                placeholder="Bairro"
                v-model="form.rem_bairro"
                name="rem_bairro"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rem_bairro')"
                v-if="form.errors.has('rem_bairro')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>CEP </label>
              <b-form-input
                type="text"
                placeholder="CEP"
                v-model="form.rem_cep"
                name="rem_cep"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rem_cep')"
                v-if="form.errors.has('rem_cep')"
              ></b-form-feedback>
            </b-col>
            <!-- <b-col class="p-0" md="2">
              <label>Email</label>
              <b-form-input
                type="text"
                placeholder="Email"
                v-model="form.rem_email"
                name="rem_email"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rem_email')"
                v-if="form.errors.has('rem_email')"
              ></b-form-feedback>
            </b-col> -->
            <b-col class="p-0" md="2">
              <label>Telefone </label>
              <b-form-input
                type="text"
                placeholder="Telefone"
                v-model="form.rem_telefone"
                name="rem_telefone"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rem_telefone')"
                v-if="form.errors.has('rem_telefone')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row>
            <h6 class="mt-1" style="">Destinatario</h6>
          </b-row>
          <b-row>
            <b-col class="p-0" md="6">
              <label>Destinatario</label>
              <b-form-input
                type="text"
                placeholder="Destinatario"
                v-model="destinatario"
                name="destinatario"
                :disabled="this.modal_acao == 'u'"
              >
              </b-form-input>
            </b-col>
            <b-col class="p-0" md="2" sm="6">
              <label>Inscrição Estadual </label>
              <b-form-input
                type="text"
                placeholder="Inscrição Estadual"
                v-model="form.des_ie"
                name="des_ie"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('des_ie')"
                v-if="form.errors.has('des_ie')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Município</label>
              <multiselect
                v-model="desMunicipioSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsMunicipio"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Municipio ( Digite ao menos 3 caracteres )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingMunicipio"
                :id="this.rec_uf"
                :disabled="this.rec_uf == null"
                @search-change="listaMunicipio"
                @click="limpaOptionsMunicipio"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Endereço </label>
              <b-form-input
                type="text"
                placeholder="Endereço"
                v-model="form.des_endereco"
                name="des_endereco"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('des_endereco')"
                v-if="form.errors.has('des_endereco')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Bairro </label>
              <b-form-input
                type="text"
                placeholder="Bairro"
                v-model="form.des_bairro"
                name="des_bairro"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('des_bairro')"
                v-if="form.errors.has('des_bairro')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>CEP </label>
              <b-form-input
                type="text"
                placeholder="CEP"
                v-model="form.des_cep"
                name="des_cep"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('des_cep')"
                v-if="form.errors.has('des_cep')"
              ></b-form-feedback>
            </b-col>
            <!-- <b-col class="p-0" md="2">
              <label>Email</label>
              <b-form-input
                type="text"
                placeholder="Email"
                v-model="form.des_email"
                name="des_email"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('des_email')"
                v-if="form.errors.has('des_email')"
              ></b-form-feedback>
            </b-col> -->
            <b-col class="p-0" md="2">
              <label>Telefone </label>
              <b-form-input
                type="text"
                placeholder="Telefone"
                v-model="form.des_telefone"
                name="des_telefone"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('des_telefone')"
                v-if="form.errors.has('des_telefone')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row>
            <h6 class="mt-1" style="">Recebedor</h6>
          </b-row>
          <b-row>
            <b-col class="p-0" md="6">
              <label>Recebedor</label>
              <b-form-input
                type="text"
                placeholder="Recebedor"
                v-model="recebedor"
                name="recebedor"
                :disabled="this.modal_acao == 'u'"
              >
              </b-form-input>
            </b-col>
            <b-col class="p-0" md="2" sm="6">
              <label>Inscrição Estadual </label>
              <b-form-input
                type="text"
                placeholder="Inscrição Estadual"
                v-model="form.rec_ie"
                name="rec_ie"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rec_ie')"
                v-if="form.errors.has('rec_ie')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Município</label>
              <multiselect
                v-model="recMunicipioSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsMunicipio"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Municipio ( Digite ao menos 3 caracteres )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingMunicipio"
                :id="this.tom_uf"
                :disabled="this.tom_uf == null"
                @search-change="listaMunicipio"
                @click="limpaOptionsMunicipio"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Endereço </label>
              <b-form-input
                type="text"
                placeholder="Endereço"
                v-model="form.rec_endereco"
                name="rec_endereco"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rec_endereco')"
                v-if="form.errors.has('rec_endereco')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Bairro </label>
              <b-form-input
                type="text"
                placeholder="Bairro"
                v-model="form.rec_bairro"
                name="rec_bairro"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rec_bairro')"
                v-if="form.errors.has('rec_bairro')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>CEP </label>
              <b-form-input
                type="text"
                placeholder="CEP"
                v-model="form.rec_cep"
                name="rec_cep"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rec_cep')"
                v-if="form.errors.has('rec_cep')"
              ></b-form-feedback>
            </b-col>
            <!-- <b-col class="p-0" md="2">
              <label>Email</label>
              <b-form-input
                type="text"
                placeholder="Email"
                v-model="form.rec_email"
                name="rec_email"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rec_email')"
                v-if="form.errors.has('rec_email')"
              ></b-form-feedback>
            </b-col> -->
            <b-col class="p-0" md="2">
              <label>Telefone </label>
              <b-form-input
                type="text"
                placeholder="Telefone"
                v-model="form.rec_telefone"
                name="rec_telefone"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('rec_telefone')"
                v-if="form.errors.has('rec_telefone')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row>
            <h6 class="mt-1" style="">Tomador</h6>
          </b-row>
          <b-row>
            <b-col class="p-0">
              <!-- <label>Tomador</label> -->
              <b-form-radio-group v-model="form.tomador" name="tomador">
                <b-row>
                  <b-col>
                    <b-form-radio value="0"> Remetente</b-form-radio>
                  </b-col>
                  <b-col>
                    <b-form-radio value="1"> Expedidor</b-form-radio>
                  </b-col>
                  <b-col>
                    <b-form-radio value="2"> Recebedor</b-form-radio>
                  </b-col>
                  <b-col>
                    <b-form-radio value="3"> Destinatário</b-form-radio>
                  </b-col>
                  <b-col>
                    <b-form-radio value="4"> Outros</b-form-radio>
                  </b-col>
                </b-row>
              </b-form-radio-group>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tomador')"
                v-if="form.errors.has('tomador')"
              ></b-form-feedback>
            </b-col>
          </b-row>
          <b-row v-if="form.tomador == 4">
            <b-col class="p-0" md="6">
              <label>Tomador - Outros</label>
              <multiselect
                v-model="tomadorOutrosSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsTomador"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingTom"
                @search-change="listaClientesTomador"
              ></multiselect>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('pessoa_id_tom')"
                v-if="form.errors.has('pessoa_id_tom')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2" sm="6">
              <label>Inscrição Estadual </label>
              <b-form-input
                type="text"
                placeholder="Inscrição Estadual"
                v-model="form.tom_ie"
                name="tom_ie"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tom_ie')"
                v-if="form.errors.has('tom_ie')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Município</label>
              <multiselect
                v-model="tomMunicipioSelected"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsMunicipio"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Municipio ( Digite ao menos 3 caracteres )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingMunicipio"
                :id="this.des_uf"
                :disabled="this.des_uf == null"
                @search-change="listaMunicipio"
                @click="limpaOptionsMunicipio"
              ></multiselect>
            </b-col>
            <b-col class="p-0" md="4">
              <label>Endereço </label>
              <b-form-input
                type="text"
                placeholder="Endereço"
                v-model="form.tom_endereco"
                name="tom_endereco"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tom_endereco')"
                v-if="form.errors.has('tom_endereco')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>Bairro </label>
              <b-form-input
                type="text"
                placeholder="Bairro"
                v-model="form.tom_bairro"
                name="tom_bairro"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tom_bairro')"
                v-if="form.errors.has('tom_bairro')"
              ></b-form-feedback>
            </b-col>
            <b-col class="p-0" md="2">
              <label>CEP </label>
              <b-form-input
                type="text"
                placeholder="CEP"
                v-model="form.tom_cep"
                name="tom_cep"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tom_cep')"
                v-if="form.errors.has('tom_cep')"
              ></b-form-feedback>
            </b-col>
            <!-- <b-col class="p-0" md="2">
              <label>Email</label>
              <b-form-input
                type="text"
                placeholder="Email"
                v-model="form.tom_email"
                name="tom_email"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tom_email')"
                v-if="form.errors.has('tom_email')"
              ></b-form-feedback>
            </b-col> -->
            <b-col class="p-0" md="2">
              <label>Telefone </label>
              <b-form-input
                type="text"
                placeholder="Telefone"
                v-model="form.tom_telefone"
                name="tom_telefone"
              >
              </b-form-input>
              <b-form-feedback
                class="text-danger"
                v-text="form.errors.get('tom_telefone')"
                v-if="form.errors.has('tom_telefone')"
              ></b-form-feedback>
            </b-col>
          </b-row>
        </b-container>
      </form>

      <div slot="modal-footer" class="w-100">
        <div class="float-left">
          <spinner v-if="loading" message="Processando..."></spinner>
          <spinner v-if="loadingCep" message="buscando endereço..."></spinner>
          <spinner
            v-if="loadingAddDoc"
            message="buscando documento..."
          ></spinner>
        </div>
        <div class="float-right">
          <div class="float-left" v-if="this.errors_array.length > 0">
            <b-btn
              class="badge badge-warning"
              @click="showPopover = !showPopover"
              id="popoverButton-sync"
              v-b-tooltip.hover.left="
                'Clique aqui para ver os erros encontrados'
              "
              variant="warning"
              ><i class="fa fa-exclamation-triangle fa-2x"></i
            ></b-btn>

            <b-popover
              :show.sync="showPopover"
              target="popoverButton-sync"
              title="<strong>Erros Encontrados</strong>"
              data-html="true"
              placement="leftbottom"
            >
              <table class="table" id="mais">
                <tbody>
                  <tr
                    class="bg-gray-light"
                    style="display: table-row"
                    v-for="item in this.errors_array"
                  >
                    <td>
                      {{ item.erro }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-popover>
          </div>
          &nbsp;

          <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
          <b-btn
            @click="handleOk($event)"
            variant="secondary"
            :disabled="isDisabled"
          >
            Enviar
          </b-btn>
        </div>
      </div>
    </b-modal>
    <BuscarDocFiscal ref="buscardocfiscal"> </BuscarDocFiscal>
    <EditarDocFiscal ref="editardocfiscal"> </EditarDocFiscal>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import BuscarDocFiscal from "../components/BuscarDocFiscal";
import EditarDocFiscal from "../components/EditarDocFiscal";

export default {
  components: {
    BuscarDocFiscal,
    EditarDocFiscal,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingFor: false,
      isFullscreen: false,
      remUfSelected: [],
      expUfSelected: [],
      isLoadingUf: false,
      fornecedorSelected: [],
      errors_array: [],
      optionsFornecedor: [],
      optionsExpedidor: [],
      optionsRecebedor: [],
      expMunicipioSelected: [],
      optionsTomador: [],
      optionsModelo: [],
      optionsParamCst: [],
      isLoadingExp: false,
      isLoadingMunicipio: false,
      isLoadingRec: false,
      isLoadingTom: false,
      isLoadingEnderecoEmi: false,
      showPopoverChaveNFe: false,
      showPopover: false,
      loadingCep: false,
      loadingCepEmi: false,
      loadingCepDes: false,
      loadingAddDoc: false,
      expedidor: "",
      emitente: "",
      remetente: "",
      destinatario: "",
      exp_uf: "",
      recebedor: "",
      emiMunicipioSelected: [],
      remMunicipioSelected: [],
      desMunicipioSelected: [],
      recMunicipioSelected: [],
      tomMunicipioSelected: [],
      emi_uf: "",
      rem_uf: "",
      rec_uf: "",
      tom_uf: "",
      des_uf: "",
      emitenteSelected: [],
      optionsEmitente: [],
      isLoadingEmi: false,
      remetenteSelected: [],
      optionsRemetente: [],
      isLoadingRem: false,
      optionsMunicipio: [],
      destinatarioSelected: [],
      optionsDestinatario: [],
      isLoadingDes: false,
      recebedorSelected: [],
      optionsRecebedor: [],
      isLoadingRec: false,
      expedidorSelected: [],
      recebedorSelected: [],
      tomadorOutrosSelected: [],
      vn_vlr_cte: 0,
      mascaraEmiNfe: "###.###.###-##",
      mascaraDesNfe: "###.###.###-##",
      mascaraDesCte: "###.###.###-##",
      form: new Form({
        doc_id: "",
        exp_ie: "",
        exp_endereco: "",
        exp_bairro: "",
        exp_cep: "",
        // exp_email: "",
        exp_telefone: "",
        emi_ie: "",
        emi_endereco: "",
        emi_bairro: "",
        emi_cep: "",
        // emi_email: "",
        emi_telefone: "",
        rem_ie: "",
        rem_endereco: "",
        rem_bairro: "",
        rem_cep: "",
        // rem_email: "",
        rem_telefone: "",
        des_ie: "",
        des_endereco: "",
        des_bairro: "",
        des_cep: "",
        // des_email: "",
        des_telefone: "",
        rec_ie: "",
        rec_endereco: "",
        rec_bairro: "",
        rec_cep: "",
        // rec_email: "",
        rec_telefone: "",
        // pessoa_id_exp: "",
        // pessoa_id_rec: "",
        // pessoa_id_rem: "",
        // pessoa_id_des: "",
        tom_ie: "",
        tom_endereco: "",
        tom_bairro: "",
        tom_cep: "",
        tom_telefone: "",
        pessoa_id_tom: "",
        tomador: "",
        exp_cd_municipio: "",
        exp_uf: "",
        exp_nome_municipio: "",
        emi_cd_municipio: "",
        emi_uf: "",
        emi_nome_municipio: "",
        rem_cd_municipio: "",
        rem_uf: "",
        rem_nome_municipio: "",
        des_cd_municipio: "",
        des_uf: "",
        des_nome_municipio: "",
        rec_cd_municipio: "",
        rec_uf: "",
        rec_nome_municipio: "",
        tom_cd_municipio: "",
        tom_uf: "",
        tom_nome_municipio: "",
      }),
      helpForm: new Form({
        statusRecord: [],
        bcliente_id_active: "",
        params: [],
        search: "",
        uf: "",
      }),
      fields: [],
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: {},
    };
  },
  watch: {
    expedidorSelected(obj) {
      this.form.pessoa_id_exp = obj.value;
    },
    recebedorSelected(obj) {
      this.form.pessoa_id_rec = obj.value;
    },
    // emitenteSelected(obj) {
    //   this.form.pessoa_id_rec = obj.value;
    // },
    remetenteSelected(obj) {
      this.form.pessoa_id_rem = obj.value;
    },
    destinatarioSelected(obj) {
      this.form.pessoa_id_des = obj.value;
    },
    tomadorOutrosSelected(obj) {
      this.form.pessoa_id_tom = obj.value;
    },
    expMunicipioSelected(obj) {
      console.log(obj);
      this.form.exp_cd_municipio = obj.cd_municipio;
      this.form.exp_uf = obj.emi_uf;
      this.form.exp_nome_municipio = obj.nome_municipio;
    },
    emiMunicipioSelected(obj) {
      this.form.emi_cd_municipio = obj.cd_municipio;
      this.form.emi_uf = obj.emi_uf;
      this.form.emi_nome_municipio = obj.nome_municipio;
    },
    remMunicipioSelected(obj) {
      this.form.rem_cd_municipio = obj.cd_municipio;
      this.form.rem_nome_municipio = obj.nome_municipio;
    },
    remUfSelected(obj) {
      this.form.rem_uf = obj.value;
    },
    expUfSelected(obj) {
      this.form.exp_uf = obj.value;
    },
    desMunicipioSelected(obj) {
      this.form.des_cd_municipio = obj.cd_municipio;
      this.form.des_uf = obj.emi_uf;
      this.form.des_nome_municipio = obj.nome_municipio;
    },
    recMunicipioSelected(obj) {
      this.form.rec_cd_municipio = obj.cd_municipio;
      this.form.rec_uf = obj.emi_uf;
      this.form.rec_nome_municipio = obj.nome_municipio;
    },
    tomMunicipioSelected(obj) {
      this.form.tom_cd_municipio = obj.cd_municipio;
      this.form.tom_uf = obj.emi_uf;
      this.form.tom_nome_municipio = obj.nome_municipio;
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate();
      }
    },
    onUpdate() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/cte/updatepartesenv")
        .then((response) => {
          new ReturnApi(response, this);
          // if (this.metodo != null) {
          //   this.metodo();
          // } else {
          //   this.$parent.$parent.onFilterReset();
          // }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({ erro: obj });
                });
              }
            }
          }
        });
    },
    onEdit(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Editar Partes Envolvidas CTE";
      this.modal_botao = "Alterar CTE " + data.b_modal.descr;
      this.modal_acao = "u";
      this.form.reset();
      this.tomadorOutrosSelected = [];
      this.exp_uf = data.doc_cte_partes_env.exp_uf;
      this.emi_uf = data.doc_cte_partes_env.emi_uf;
      // this.rem_uf = data.doc_cte_partes_env.rem_uf;
      this.rec_uf = data.doc_cte_partes_env.rec_uf;
      this.tom_uf = data.doc_cte_partes_env.tom_uf;
      this.des_uf = data.doc_cte_partes_env.des_uf;

      if (this.exp_uf != null) {
        this.expMunicipioSelected = {
          label: data.doc_cte_partes_env.exp_nome_municipio,
        };
        this.expUfSelected = {
          label: data.doc_cte_partes_env.exp_uf,
          value: data.doc_cte_partes_env.exp_uf,
        };
        this.form.exp_cd_municipio = data.doc_cte_partes_env.exp_cd_municipio;
        this.form.exp_uf = data.doc_cte_partes_env.exp_uf;
        this.form.exp_nome_municipio =
          data.doc_cte_partes_env.exp_nome_municipio;
      }

      if (this.emi_uf != null) {
        this.emiMunicipioSelected = {
          label: data.doc_cte_partes_env.emi_nome_municipio,
        };
        this.form.emi_cd_municipio = data.doc_cte_partes_env.emi_cd_municipio;
        this.form.emi_uf = data.doc_cte_partes_env.emi_uf;
        this.form.emi_nome_municipio =
          data.doc_cte_partes_env.emi_nome_municipio;
      }

      if (this.rem_uf != null) {
        this.remMunicipioSelected = {
          label: data.doc_cte_partes_env.rem_nome_municipio,
        };
        this.remUfSelected = {
          label: data.doc_cte_partes_env.rem_uf,
          value: data.doc_cte_partes_env.rem_uf,
        };
        this.form.rem_cd_municipio = data.doc_cte_partes_env.rem_cd_municipio;
        this.form.rem_uf = data.doc_cte_partes_env.rem_uf;
        this.form.rem_nome_municipio =
          data.doc_cte_partes_env.rem_nome_municipio;
      }

      if (this.rec_uf != null) {
        this.recMunicipioSelected = {
          label: data.doc_cte_partes_env.rec_nome_municipio,
        };
        this.form.rec_cd_municipio = data.doc_cte_partes_env.rec_cd_municipio;
        this.form.rec_uf = data.doc_cte_partes_env.rec_uf;
        this.form.rec_nome_municipio =
          data.doc_cte_partes_env.rec_nome_municipio;
      }

      if (this.tom_uf != null) {
        this.tomMunicipioSelected = {
          label: data.doc_cte_partes_env.tom_nome_municipio,
        };
        this.form.tom_cd_municipio = data.doc_cte_partes_env.tom_cd_municipio;
        this.form.tom_uf = data.doc_cte_partes_env.tom_uf;
        this.form.tom_nome_municipio =
          data.doc_cte_partes_env.tom_nome_municipio;
      }

      if (this.des_uf != null) {
        this.desMunicipioSelected = {
          label: data.doc_cte_partes_env.des_nome_municipio,
        };
        this.form.des_cd_municipio = data.doc_cte_partes_env.des_cd_municipio;
        this.form.des_uf = data.doc_cte_partes_env.des_uf;
        this.form.des_nome_municipio =
          data.doc_cte_partes_env.des_nome_municipio;
      }

      this.form.doc_id = data.doc_id;
      if (data.doc_cte_partes_env.exp_nome_fantasia == null) {
        this.expedidor = data.doc_cte_partes_env.exp_nome;
      } else {
        this.expedidor = data.doc_cte_partes_env.exp_nome_fantasia;
      }

      if (data.doc_cte_partes_env.emi_nome_fantasia == null) {
        this.emitente = data.doc_cte_partes_env.emi_nome;
      } else {
        this.emitente = data.doc_cte_partes_env.emi_nome_fantasia;
      }

      if (data.doc_cte_partes_env.rem_nome_fantasia == null) {
        this.remetente = data.doc_cte_partes_env.rem_nome;
      } else {
        this.remetente = data.doc_cte_partes_env.rem_nome_fantasia;
      }
      if (data.doc_cte_partes_env.des_nome_fantasia == null) {
        this.destinatario = data.doc_cte_partes_env.des_nome;
      } else {
        this.destinatario = data.doc_cte_partes_env.des_nome_fantasia;
      }
      if (data.doc_cte_partes_env.rec_nome_fantasia == null) {
        this.recebedor = data.doc_cte_partes_env.rec_nome;
      } else {
        this.recebedor = data.doc_cte_partes_env.rec_nome_fantasia;
      }

      this.form.exp_ie = data.doc_cte_partes_env.exp_ie;
      this.form.exp_endereco = data.doc_cte_partes_env.exp_endereco;
      this.form.exp_bairro = data.doc_cte_partes_env.exp_bairro;
      this.form.exp_cep = data.doc_cte_partes_env.exp_cep;
      // this.form.exp_email = data.doc_cte_partes_env.exp_email;
      this.form.exp_telefone = data.doc_cte_partes_env.exp_telefone;

      this.form.tom_ie = data.doc_cte_partes_env.tom_ie;
      this.form.tom_endereco = data.doc_cte_partes_env.tom_endereco;
      this.form.tom_bairro = data.doc_cte_partes_env.tom_bairro;
      this.form.tom_cep = data.doc_cte_partes_env.tom_cep;
      // this.form.tom_email = data.doc_cte_partes_env.tom_email;
      this.form.tom_telefone = data.doc_cte_partes_env.tom_telefone;

      this.form.emi_ie = data.doc_cte_partes_env.emi_ie;
      this.form.emi_endereco = data.doc_cte_partes_env.emi_endereco;
      this.form.emi_bairro = data.doc_cte_partes_env.emi_bairro;
      this.form.emi_cep = data.doc_cte_partes_env.emi_cep;
      // this.form.emi_email = data.doc_cte_partes_env.emi_email;
      this.form.emi_telefone = data.doc_cte_partes_env.emi_telefone;

      this.form.rem_ie = data.doc_cte_partes_env.rem_ie;
      this.form.rem_endereco = data.doc_cte_partes_env.rem_endereco;
      this.form.rem_bairro = data.doc_cte_partes_env.rem_bairro;
      this.form.rem_cep = data.doc_cte_partes_env.rem_cep;
      // this.form.rem_email = data.doc_cte_partes_env.rem_email;
      this.form.rem_telefone = data.doc_cte_partes_env.rem_telefone;

      this.form.des_ie = data.doc_cte_partes_env.des_ie;
      this.form.des_endereco = data.doc_cte_partes_env.des_endereco;
      this.form.des_bairro = data.doc_cte_partes_env.des_bairro;
      this.form.des_cep = data.doc_cte_partes_env.des_cep;
      // this.form.des_email = data.doc_cte_partes_env.des_email;
      this.form.des_telefone = data.doc_cte_partes_env.des_telefone;

      this.form.rec_ie = data.doc_cte_partes_env.rec_ie;
      this.form.rec_endereco = data.doc_cte_partes_env.rec_endereco;
      this.form.rec_bairro = data.doc_cte_partes_env.rec_bairro;
      this.form.rec_cep = data.doc_cte_partes_env.rec_cep;
      // this.form.rec_email = data.doc_cte_partes_env.rec_email;
      this.form.rec_telefone = data.doc_cte_partes_env.rec_telefone;
      if (data.doc_cte_partes_env.tom_tomador != null) {
        this.form.tomador = data.doc_cte_partes_env.tom_tomador;
      }
      if (data.doc_cte_partes_env.tom_tomador == null) {
        this.form.tomador = data.tomador;
      }

      if (data.tomador == 4) {
        this.tomadorOutrosSelected = {
          label:
            data.doc_cte_partes_env.tom_nome +
            " - " +
            data.doc_cte_partes_env.tom_cnpj +
            " - " +
            data.doc_cte_partes_env.tom_ie,

          value: data.doc_cte_partes_env.pessoa_id_tom,
        };
      }

      this.errors_array = "";
      this.errors_array = [];
      this.$refs.modal_form.show();
    },

    listaClientesTomador(search) {
      if (search.length >= 3) {
        this.isLoadingTom = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsTomador = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj) => {
              this.optionsTomador.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingTom = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },

    listaMunicipio(search, uf) {
      this.optionsMunicipio = [];
      if (search.length >= 3) {
        this.isLoadingMunicipio = true;
        this.helpForm.search = search;
        this.helpForm.uf = uf;
        this.helpForm
          .post("/api/cte/jsonlist/municipio")
          .then((response) => {
            this.optionsMunicipio = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsMunicipio.push({
                  label: obj.nome,
                  cd_municipio: obj.cd_ibge,
                  nome_municipio: obj.nome,
                  emi_uf: obj.uf.cd,
                  value: obj.municipio_id,
                });
              });
            }
            this.isLoadingMunicipio = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },

    getCep(en_tipo) {
      if (en_tipo == 1) {
        this.loadingCepEmi = true;
        this.helpForm.cep_busca = this.helpForm.emi_cep;
      } else if (en_tipo == 2) {
        this.loadingCepDes = true;
        this.helpForm.cep_busca = this.helpForm.des_cep;
      } else if (en_tipo == 3) {
        this.loadingCepEmi = true;
        this.helpForm.cep_busca = this.form_doctransp.emi_cep;
      } else if (en_tipo == 4) {
        this.loadingCepDes = true;
        this.helpForm.cep_busca = this.form_doctransp.des_cep;
      }
      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");

      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              if (en_tipo == 1) {
                this.helpForm.errors.clear();
                response.forEach((obj) => {
                  this.helpForm.emi_endereco = obj.logradouro;
                  this.helpForm.emi_bairro = obj.bairro;
                  this.helpForm.emi_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.helpForm.emi_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 2) {
                this.helpForm.errors.clear();
                response.forEach((obj) => {
                  this.helpForm.des_endereco = obj.logradouro;
                  this.helpForm.des_bairro = obj.bairro;
                  this.helpForm.des_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.helpForm.des_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 3) {
                this.form_doctransp.errors.clear();
                response.forEach((obj) => {
                  this.form_doctransp.emi_endereco = obj.logradouro;
                  this.form_doctransp.emi_bairro = obj.bairro;
                  this.form_doctransp.emi_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.form_doctransp.emi_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 4) {
                this.form_doctransp.errors.clear();
                response.forEach((obj) => {
                  this.form_doctransp.des_endereco = obj.logradouro;
                  this.form_doctransp.des_bairro = obj.bairro;
                  this.form_doctransp.des_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.form_doctransp.des_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              }
              this.loadingCep = false;
              this.loadingCepEmi = false;
              this.loadingCepDes = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              this.loadingCepEmi = false;
              this.loadingCepDes = false;
              new ReturnApi(errors, this);
            });
        } else {
          if (en_tipo == 1) {
            var errors = { errors: { emi_cep: ["Cep inválido"] } };
            this.helpForm.errors.record(errors.errors);
          } else if (en_tipo == 2) {
            var errors = { errors: { des_cep: ["Cep inválido"] } };
            this.helpForm.errors.record(errors.errors);
          } else if (en_tipo == 3) {
            var errors = { errors: { emi_cep: ["Cep inválido"] } };
            this.form_doctransp.errors.record(errors.errors);
          } else if (en_tipo == 4) {
            var errors = { errors: { des_cep: ["Cep inválido"] } };
            this.form_doctransp.errors.record(errors.errors);
          }
        }
      }
      this.loadingCep = false;
      this.loadingCepEmi = false;
      this.loadingCepDes = false;
    },
    ajustaMascara(tipo, origem) {
      //Valor, destinatario/emitente, nfe/cte
      if (origem == 1) {
        //NFE
        if (tipo == 1) {
          //Emitente
          if (this.helpForm.emi_tp_pessoa == 1) {
            //PF
            this.mascaraEmiNfe = "###.###.###-##";
          }
          if (this.helpForm.emi_tp_pessoa == 2) {
            //PJ
            this.mascaraEmiNfe = "##.###.###/####-##";
          }
          if (this.helpForm.emi_tp_pessoa == 3) {
            //PO
            this.mascaraEmiNfe = "XXXXXXXXXXXXXXXX";
          }
        }
        if (tipo == 2) {
          //Destinatario
          if (this.helpForm.des_tp_pessoa == 1) {
            //PF
            this.mascaraDesNfe = "###.###.###-##";
          }
          if (this.helpForm.des_tp_pessoa == 2) {
            //PJ
            this.mascaraDesNfe = "##.###.###/####-##";
          }
          if (this.helpForm.des_tp_pessoa == 3) {
            //PO
            this.mascaraDesNfe = "XXXXXXXXXXXXXXXX";
          }
        }
      }
      if (origem == 2) {
        //CTE
        if (tipo == 2) {
          //Destinatario
          if (this.helpForm.des_tp_pessoa == 1) {
            //PF
            this.mascaraDesCte = "###.###.###-##";
          }
          if (this.helpForm.des_tp_pessoa == 2) {
            //PJ
            this.mascaraDesCte = "##.###.###/####-##";
          }
          if (this.helpForm.des_tp_pessoa == 3) {
            //PO
            this.mascaraDesCte = "XXXXXXXXXXXXXXXX";
          }
        }
      }
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    limpaOptionsMunicipio() {
      this.optionsMunicipio = [];
    },
    formatNumberQtd(value) {
      return accounting.formatNumber(value, 3, ".", ",");
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    produto_predominante_left() {
      var char = this.form.produto_predominante.length,
        limit = 60;
      return limit - char + " / " + limit + " caracteres disponíveis";
    },
    obs_left() {
      var char = this.form.obs.length,
        limit = 2000;
      return limit - char + " / " + limit + " caracteres disponíveis";
    },
  },
};
</script>
